import type { ArticleCategory } from "@brookbush/types";

import Carousel from "~/components/Carousel";
import LoadingAnimation from "~/components/LoadingAnimation";
import ArticlesCard from "~/pages/articles/components/ArticlesCard";

const ArticlesOverview = ({
	categories,
	featuredArticles,
	latestArticles,
	scholarlyArticles,
}: {
	categories: Array<ArticleCategory>;
	featuredArticles: ArticleCategory;
	latestArticles: ArticleCategory;
	scholarlyArticles: ArticleCategory;
}) => {
	return (
		<div className="flex w-full flex-col gap-4 phablet:gap-6">
			<div className="flex flex-col gap-4">
				{!categories ? (
					<div className="flex h-[75vh] items-center justify-center">
						<LoadingAnimation />
					</div>
				) : !categories.length ? (
					<div className="flex h-[calc(100vh-25rem)] phablet:h-[calc(100vh-12rem)] w-full items-center justify-center">
						<h2 className="font-semibold phablet:text-2xl text-xl">
							No Articles Found
						</h2>
					</div>
				) : (
					<div className="flex w-full flex-col gap-4">
						<Carousel
							title="Featured Articles"
							key="featured"
							href="/articles/categories/featured"
						>
							{featuredArticles.articles?.map((article) => (
								<ArticlesCard key={article._id} {...article}></ArticlesCard>
							))}
						</Carousel>
						<Carousel
							title="Latest Articles"
							key="latest"
							href="/articles/categories/latest"
						>
							{latestArticles.articles?.map((article) => (
								<ArticlesCard key={article._id} {...article}></ArticlesCard>
							))}
						</Carousel>
						<Carousel
							title="Scholarly Articles"
							key="scholarly"
							href="/articles/categories/scholarly"
						>
							{scholarlyArticles.articles?.map((article) => (
								<ArticlesCard key={article._id} {...article}></ArticlesCard>
							))}
						</Carousel>
						{categories.map((category) => (
							<Carousel
								title={category.title}
								key={category._id}
								href={`/articles/categories/${category.slug}`}
							>
								{category.articles?.map((article) => (
									<ArticlesCard key={article._id} {...article}></ArticlesCard>
								))}
							</Carousel>
						))}
					</div>
				)}
			</div>
		</div>
	);
};

export default ArticlesOverview;
